module.exports = __webpack_public_path__ + "static/emerson-3963f47be8059b63d027a760e46b899c.png";